import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { getSortState, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity, getEntities } from './company.reducer';
import { toast } from 'react-toastify';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { DEFAULT_ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';

export const CompanyDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const [paginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'name'), props.location.search)
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const companyEntity = useAppSelector(state => state.company.entity);
  const updateSuccess = useAppSelector(state => state.company.updateSuccess);
  const errorMessage = useAppSelector(state => state.company.errorMessage);

  const handleClose = () => {
    props.history.push('/company' + props.location.search);
    
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const errorDeleting = () => {
    props.history.push('/company' + props.location.search);

    return toast.error('Não foi possível excluir a empresa.');
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (errorMessage) {
      errorDeleting();
    }
  }, [errorMessage]);

  const confirmDelete = () => {
    dispatch(deleteEntity(companyEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="companyDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.company.delete.question">
        <Translate contentKey="fleetSenseApp.company.delete.question" interpolate={{ id: companyEntity.name }}>
          Are you sure you want to delete this Company?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="app-confirm-delete-company" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CompanyDeleteDialog;
